import { mapActions, mapGetters } from 'vuex'

import { url } from '@/config'

export const invoiceMixin = {
  computed: {
    ...mapGetters({
      'invoice': 'invoices/invoice',
      'invoices': 'invoices/all',
      'clientInvoices': 'invoices/clientInvoices'
    }),
    invoiceNumber () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions({
      'getInvoices': 'invoices/getInvoices',
      'getClientInvoices': 'invoices/getClientInvoices',
      'getSingleInvoice': 'invoices/getInvoice',
      'addSingleAdjustment': 'invoices/addAdjustment',
      'updateSingleAdjustment': 'invoices/updateAdjustment',
      'deleteSingleAdjustment': 'invoices/deleteAdjustment',
      'updateInvoice': 'invoices/updateInvoice',
      'uploadInvoiceFile': 'invoices/uploadFile'
    }),
    delimitNumbers (str) {
      return (str + '').replace(/\b(\d+)((\.\d+)*)\b/g, (a, b, c) => {
        return (b.charAt(0) > 0 && !(c || '.').lastIndexOf('.') ? b.replace(/(\d)(?=(\d{3})+$)/g, '$1,') : b) + c
      })
    },
    currencySymbol (currency) {
      if (currency === 'gbp') {
        return '&pound;'
      }
      if (currency === 'usd') {
        return '&dollar;'
      }
      if (currency === 'eur') {
        return '&dollar;'
      }
    },
    downloadUrl (path) {
      return `${url}${path.charAt(0) === '/' ? path.substring(1) : path}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/invoiceMixin.js